// =============================================================================
//  ARABIC TRANSLATION FILE  —  ملف الترجمة العربية
// =============================================================================
//  Left side  = the English text exactly as it is in the app. DO NOT change it.
//  Right side = your Arabic. Write it between the empty quotes "".
//
//      "Sign in": "تسجيل الدخول",
//
//  • If you leave "" empty, the English text stays on screen (nothing breaks).
//  • Keep {0} {1} {2} in your Arabic: they are replaced by live values
//    (a number, a name, a date...). You can move them anywhere in the sentence:
//      "Row {0} is incomplete": "السطر {0} غير مكتمل",
//  • Keep HTML tags like <b> </b> <small> </small> around the same words.
//  • If your Arabic contains a double quote " write it as \"
//  • Every line ends with a comma ,
//  • A few sentences have a placeholder that only adds the English plural "s",
//    e.g. "{0} Sent to {1} station{2}." — in Arabic just leave {2} out.
//
//  After editing: save the file. In development (npm start) the page reloads
//  by itself; for production run npm run build as usual.
// =============================================================================

const ar = {

  // ───── Shared — used on several pages ─────
  "Error!": "خطأ!",
  "Connection problem.": "مشكلة في الاتصال.",
  "Close": "إغلاق",
  "Password": "كلمة المرور",
  "Error": "خطأ",
  "Not logged in.": "لم يتم تسجيل الدخول.",
  "Refresh": "تحديث",
  "Print": "طباعة",
  "Serial No:": "الرقم التسلسلي:",
  "All Stations": "كل المحطات",
  "Card ID *": "رقم البطاقة *",
  "e.g. A1B2C3D4 — or tap a card on the reader": "مثال: A1B2C3D4 — أو مرّر البطاقة على القارئ",
  "Station required": "المحطة مطلوبة",
  "Saved": "تم الحفظ",
  "Error {0}": "خطأ {0}",
  "Save failed.": "فشل الحفظ.",
  "Connection error": "خطأ في الاتصال",
  "Saving…": "جارٍ الحفظ...",
  "Create Card": "إنشاء البطاقة",
  "Delete this card?": "حذف هذه البطاقة؟",
  "Yes, delete": "نعم، احذف",
  "Cancel": "إلغاء",
  "Deleted": "تم الحذف",
  "Card removed.": "تم حذف البطاقة.",
  "Delete failed.": "فشل الحذف.",
  "Click to sort": "اضغط للترتيب",
  "Filter by station": "تصفية حسب المحطة",
  "All stations": "كل المحطات",
  "Search": "بحث",
  "Loading…": "جارٍ التحميل...",
  "Card ID": "رقم البطاقة",
  "Station": "المحطة",
  "Created": "تاريخ الإنشاء",
  "Actions": "إجراءات",
  "No cards match your filter.": "لا توجد بطاقات تطابق التصفية.",
  "Delete card": "حذف البطاقة",
  "Car Plate": "لوحة السيارة",
  "Customer Name": "اسم العميل",
  "Shift": "الوردية",
  "Station:": "المحطة:",
  "Start:": "البداية:",
  "End:": "النهاية:",
  "ongoing": "مستمرة",
  "OK": "موافق",
  "Start": "البداية",
  "Station Serials *": "الأرقام التسلسلية للمحطات *",
  "Remove {0}": "إزالة {0}",
  "Add a station…": "إضافة محطة…",
  "All stations added": "تمت إضافة كل المحطات",
  "TIN Number": "الرقم الضريبي (TIN)",
  "Product": "المنتج",
  "Either (Diesel or Unleaded)": "أيّ منهما (ديزل أو بنزين)",
  "Diesel only": "ديزل فقط",
  "Unleaded only": "بنزين فقط",
  "License Plate": "لوحة المركبة",
  "e.g. T 324 DLS": "مثال: T 324 DLS",
  "Price": "السعر",
  "Plate": "اللوحة",
  "TIN": "الرقم الضريبي",
  "Either": "أيّ منهما",
  "No records found for the selected filters.": "لا توجد سجلات للتصفية المحددة.",
  "Search stations...": "ابحث عن محطة...",
  "Generating…": "جارٍ الإنشاء…",
  "Date": "التاريخ",
  "Tank": "الخزان",
  "Driver": "السائق",
  "Success!": "تمت العملية بنجاح!",
  "Loading...": "جارٍ التحميل...",
  "Driver Name": "اسم السائق",
  "Save": "حفظ",
  "Order ID": "رقم الطلب",
  "Pump": "المضخة",
  "Volume": "الكمية",
  "Amount": "المبلغ",
  "Export": "تصدير",
  "Total": "الإجمالي",
  "Updated": "تم التحديث",
  "TSH": "شلن",
  "L": "ل",
  "Volume (L)": "الكمية (ل)",
  "Choose a station…": "اختر محطة…",

  // ───── Login page ─────
  "Email and/or password cannot be empty!": "البريد الإلكتروني أو كلمة المرور لا يمكن أن يكونا فارغين!",
  "Try Again": "حاول مجدداً",
  "Check email and password.": "تحقق من البريد الإلكتروني وكلمة المرور.",
  "Station Automation": "أتمتة المحطات",
  "Tanks, pumps and receipts across every station in one place.": "الخزانات والمضخات والإيصالات لكل المحطات في مكان واحد.",
  "Sign in": "تسجيل الدخول",
  "Use your station account to continue.": "استخدم حساب محطتك للمتابعة.",
  "Email": "البريد الإلكتروني",
  "you@company.com": "you@company.com",
  "Hide password": "إخفاء كلمة المرور",
  "Show password": "إظهار كلمة المرور",
  "Signing in": "جارٍ تسجيل الدخول",

  // ───── Footer ─────
  "Logged in as: {0}": "مسجّل الدخول باسم: {0}",
  "Toggle fullscreen": "ملء الشاشة",
  "Hide/View menus": "إظهار/إخفاء القوائم",
  "Logout": "تسجيل الخروج",

  // ───── Not authorized page ─────
  "You are not authorized to view this page.": "ليس لديك صلاحية لعرض هذه الصفحة.",
  "back": "رجوع",
  "You Are Not Authorized.": "ليس لديك صلاحية.",

  // ───── Toolbar buttons (tooltips) ─────
  "Filter Parameters": "معايير التصفية",
  "Hide/View columns": "إظهار/إخفاء الأعمدة",

  // ───── App (session messages) ─────
  "Session Timed Out": "انتهت الجلسة",
  "Could not connect to server...": "تعذّر الاتصال بالخادم...",

  // ───── Install app prompt ─────
  "Install app": "تثبيت التطبيق",
  "Install AK4tek FMS": "تثبيت AK4tek FMS",
  "Add it to your home screen for the full app experience.": "أضفه إلى الشاشة الرئيسية لتجربة التطبيق كاملة.",
  "Install": "تثبيت",
  "Dismiss": "تجاهل",
  "Tap": "اضغط على",
  "Share, then \"Add to Home Screen\".": "مشاركة، ثم «إضافة إلى الشاشة الرئيسية».",

  // ───── ATG / Tank monitor page ─────
  "{0} / {1} L": "{0} / {1} ل",
  "Capacity: {0} L": "السعة: {0} ل",
  "Current: {0} L": "الحالي: {0} ل",
  "@15°C: {0} L": "عند 15°م: {0} ل",
  "Water: {0} L": "الماء: {0} ل",
  "Temp: {0}°C": "الحرارة: {0}°م",
  "Station Information": "معلومات المحطة",
  "License No:": "رقم الترخيص:",
  "{0} tanks": "{0} خزانات",
  "{0} tank": "{0} خزان",
  "No tank data received for this station.": "لم تصل بيانات خزانات لهذه المحطة.",
  "Refresh now": "تحديث الآن",
  "Last Updated": "آخر تحديث",
  "Summary": "الملخص",
  "{0} Stations": "{0} محطات",
  "{0} Station": "{0} محطة",
  "({0} Online), {1} Tanks": "({0} متصلة)، {1} خزانات",
  "({0} Online), {1} Tank": "({0} متصلة)، {1} خزان",

  // ───── Attendant Cards page ─────
  "{0} Sent to {1} station{2}.": "{0} تم الإرسال إلى {1} محطة.",
  "{0} — {1} of {2} station{3} not updated": "{0} — لم يتم تحديث {1} من أصل {2} محطة",
  "Saved here, but not applied at:": "تم الحفظ هنا، لكن لم يُطبَّق في:",
  "The card will not work at those pumps until it is re-saved.": "لن تعمل البطاقة على تلك المضخات حتى يُعاد حفظها.",
  "Attendant Name *": "اسم العامل *",
  "Station *": "المحطة *",
  "Select a station…": "اختر محطة…",
  "Card ID required": "رقم البطاقة مطلوب",
  "Attendant name required": "اسم العامل مطلوب",
  "Select a station for this card.": "اختر محطة لهذه البطاقة.",
  "Attendant card created.": "تم إنشاء بطاقة العامل.",
  "Add Attendant Card": "إضافة بطاقة عامل",
  "Pump Attendant Cards": "بطاقات عمّال المضخات",
  "Card ID or name…": "رقم البطاقة أو الاسم…",
  "+ Add Attendant Card": "+ إضافة بطاقة عامل",
  "Name": "الاسم",
  "No attendant cards yet — add one to get started.": "لا توجد بطاقات عمّال بعد — أضف بطاقة للبدء.",
  "Add your first attendant card": "أضف أول بطاقة عامل",

  // ───── Buses Reports page ─────
  "Not enabled": "غير مفعّل",
  "Route/bus monitoring is not enabled for this station.": "مراقبة المسارات/الحافلات غير مفعّلة لهذه المحطة.",
  "Could not fetch report": "تعذّر جلب التقرير",
  "Shift toggled": "تم تبديل الوردية",
  "Could not toggle shift": "تعذّر تبديل الوردية",
  "Report generated": "تم إنشاء التقرير",
  "{0} bus(es)": "{0} حافلة",
  "Could not generate report": "تعذّر إنشاء التقرير",
  "Actual Sales (L)": "المبيعات الفعلية (ل)",
  "Route (L)": "مخصّص المسار (ل)",
  "Status": "الحالة",
  "Buses Reports": "تقارير الحافلات",
  "Select station...": "اختر محطة...",
  "Working...": "جارٍ التنفيذ…",
  "Start / End Shift": "بدء / إنهاء الوردية",
  "No shifts yet": "لا توجد ورديات بعد",
  "Generate Report": "إنشاء التقرير",
  "Download Excel": "تنزيل Excel",
  "Select a station to begin.": "اختر محطة للبدء.",
  "No shifts yet for this station — click \"Start / End Shift\" to open one.": "لا توجد ورديات لهذه المحطة بعد — اضغط «بدء / إنهاء الوردية» لفتح وردية.",
  "No report generated yet for this shift — click \"Generate Report\".": "لم يُنشأ تقرير لهذه الوردية بعد — اضغط «إنشاء التقرير».",
  "No cards found for this station.": "لا توجد بطاقات لهذه المحطة.",
  "OVER ROUTE": "تجاوز المسار",
  "Archive — Previous Shifts": "الأرشيف — الورديات السابقة",
  "Search by date/time...": "ابحث بالتاريخ/الوقت...",
  "End": "النهاية",
  "No closed shifts yet for this station.": "لا توجد ورديات مغلقة لهذه المحطة بعد.",
  "No shifts match that search.": "لا توجد ورديات تطابق البحث.",
  "View": "عرض",

  // ───── Client Cards page ─────
  "e.g. 10TZ100614, 10TZ100615": "مثال: 10TZ100614, 10TZ100615",
  "Comma-separated. One card can be valid at several stations.": "افصل بينها بفاصلة. يمكن أن تكون البطاقة صالحة في عدة محطات.",
  "One card can be valid at several stations. Pick from the list to add.": "يمكن أن تكون البطاقة صالحة في عدة محطات. اختر من القائمة للإضافة.",
  "Failed to generate QR code.": "فشل إنشاء رمز QR.",
  "This card has no ID to encode.": "هذه البطاقة ليس لها رقم لتحويله إلى رمز.",
  "Customer Name (company or person)": "اسم العميل (شركة أو شخص)",
  "Start typing to match an existing customer…": "ابدأ الكتابة للبحث عن عميل موجود…",
  "Filled in automatically for an existing customer — edit if it's wrong.": "يُملأ تلقائياً للعميل الموجود — عدّله إن كان خاطئاً.",
  "QR Code": "رمز QR",
  "Show or reprint the QR code for this card ID.": "عرض أو إعادة طباعة رمز QR لرقم هذه البطاقة.",
  "Generate a unique card ID and its scannable QR code.": "إنشاء رقم بطاقة فريد ورمز QR قابل للمسح.",
  "Show QR": "عرض QR",
  "Generate New QR": "إنشاء QR جديد",
  "Print QR": "طباعة QR",
  "Generated QR Code": "رمز QR المُنشأ",
  "Preset Value": "القيمة المحددة مسبقاً",
  "Preset Type": "نوع القيمة المحددة",
  "amount": "مبلغ",
  "volume": "كمية",
  "Payment Method": "طريقة الدفع",
  "cash": "نقدي",
  "credit": "آجل (رصيد)",
  "Leave blank for none": "اتركه فارغاً إن لم يوجد",
  "Optional. Leave blank for no price.": "اختياري. اتركه فارغاً بدون سعر.",
  "Credit": "الرصيد",
  "Editing this sets the balance directly. Use “Add Credit” on the card instead if you just want to top up by an amount.": "تعديل هذا الحقل يغيّر الرصيد مباشرة. استخدم «إضافة رصيد» على البطاقة إذا أردت فقط زيادة الرصيد بمبلغ معيّن.",
  "Starting balance. Only drawn down for credit-payment cards.": "الرصيد الابتدائي. يُخصم منه فقط في بطاقات الدفع الآجل.",
  "Active": "فعّالة",
  "Add at least one station serial for this card.": "أضف رقماً تسلسلياً لمحطة واحدة على الأقل لهذه البطاقة.",
  "Card updated.": "تم تحديث البطاقة.",
  "Card created.": "تم إنشاء البطاقة.",
  "Edit Card": "تعديل البطاقة",
  "Add New Card": "إضافة بطاقة جديدة",
  "Save Changes": "حفظ التغييرات",
  "Enter an amount": "أدخل مبلغاً",
  "Top-up must be a positive number.": "يجب أن يكون مبلغ الشحن رقماً موجباً.",
  "Could not read current balance.": "تعذّرت قراءة الرصيد الحالي.",
  "Credit added": "تمت إضافة الرصيد",
  "New balance: {0}": "الرصيد الجديد: {0}",
  "Top-up failed.": "فشل شحن الرصيد.",
  "Add Credit — {0}": "إضافة رصيد — {0}",
  "Customer:": "العميل:",
  "Current balance:": "الرصيد الحالي:",
  "Amount to add": "المبلغ المراد إضافته",
  "e.g. 50000": "مثال: 50000",
  "New balance will be {0}.": "سيصبح الرصيد {0}.",
  "Adding…": "جارٍ الإضافة…",
  "Add Credit": "إضافة رصيد",
  "Fuel Cards": "بطاقات الوقود",
  "Card ID, customer, TIN, plate…": "رقم البطاقة، العميل، الرقم الضريبي، اللوحة…",
  "+ Add Card": "+ إضافة بطاقة",
  "Customer": "العميل",
  "Preset": "القيمة المحددة",
  "Type": "النوع",
  "Payment": "الدفع",
  "No cards yet — add one to get started.": "لا توجد بطاقات بعد — أضف بطاقة للبدء.",
  "Add your first card": "أضف أول بطاقة",
  "Inactive": "غير فعّالة",
  "Edit card": "تعديل البطاقة",
  "Add credit": "إضافة رصيد",

  // ───── Close Reports page ─────
  "Failed to load stations.": "فشل تحميل المحطات.",
  "Please select at least one station.": "يرجى اختيار محطة واحدة على الأقل.",
  "Please select a date.": "يرجى اختيار تاريخ.",
  "No close reports found for any station on {0}.": "لا توجد تقارير إغلاق لأي محطة بتاريخ {0}.",
  "Downloaded {0} with {1} station(s).": "تم تنزيل {0} ويحتوي على {1} محطة.",
  "No close report for {0}: {1}.": "لا يوجد تقرير إغلاق بتاريخ {0}: {1}.",
  "Downloaded: {0}.": "تم التنزيل: {0}.",
  "No stations processed.": "لم تتم معالجة أي محطة.",
  "Error: {0}": "خطأ: {0}",
  "Exported {0} record(s) across {1} station(s).": "تم تصدير {0} سجل من {1} محطة.",
  "Close Report": "تقرير الإغلاق",
  "All Stations (download as ZIP)": "كل المحطات (تنزيل كملف ZIP)",
  "Select one or more, or \"All Stations\" for a ZIP": "اختر محطة أو أكثر، أو «كل المحطات» لملف ZIP",
  "Report Date": "تاريخ التقرير",
  "Day of the close report": "يوم تقرير الإغلاق",
  "Download Close Report (Excel)": "تنزيل تقرير الإغلاق (Excel)",
  "Please wait…": "يرجى الانتظار…",
  "Pump vs ATG Sales Volume Comparison": "مقارنة كمية المبيعات بين المضخة و ATG",
  "Stations (blank = all, one sheet each)": "المحطات (فارغ = الكل، ورقة لكل محطة)",
  "Start Date": "تاريخ البداية",
  "Filter by start date (optional)": "تصفية حسب تاريخ البداية (اختياري)",
  "End Date": "تاريخ النهاية",
  "Filter by end date (optional)": "تصفية حسب تاريخ النهاية (اختياري)",
  "Download Pump vs ATG Sales Comparison (Excel)": "تنزيل مقارنة مبيعات المضخة و ATG (Excel)",

  // ───── Offloading Reports page ─────
  "Start date must be on or before end date.": "يجب أن يكون تاريخ البداية قبل تاريخ النهاية أو مساوياً له.",
  "Failed to load data: {0}": "فشل تحميل البيانات: {0}",
  "Supplier": "المورّد",
  "ATG Volume": "كمية ATG",
  "Order QTY": "الكمية المطلوبة",
  "Dipstick Vol": "كمية القياس اليدوي",
  "Difference (ATG - Order)": "الفرق (ATG - الطلب)",
  "Missing: {0}": "ناقص: {0}",
  "Refill added successfully.": "تمت إضافة التعبئة بنجاح.",
  "Offloading Reports": "تقارير التفريغ",
  "All My Stations": "كل محطاتي",
  "Start date": "تاريخ البداية",
  "End date": "تاريخ النهاية",
  "Export to Excel": "تصدير إلى Excel",
  "{0} record(s) — Page {1} of {2}": "{0} سجل — صفحة {1} من {2}",
  "Show only {0}": "عرض {0} فقط",
  "Combined from {0} ATG detections of the same delivery": "مدمج من {0} قراءات ATG لنفس التوريدة",
  "No Refill": "لا توجد تعبئة",
  "No records found": "لا توجد سجلات",
  "Add Refill (Manual)": "إضافة تعبئة (يدوياً)",
  "Station Serial": "الرقم التسلسلي للمحطة",
  "Tank ID": "رقم الخزان",
  "Diesel / Unleaded": "ديزل / بنزين",
  "Supplier Name": "اسم المورّد",
  "Tanker License Plate": "لوحة الصهريج",
  "Issue Date": "تاريخ الإصدار",
  "Hour (0-23)": "الساعة (0-23)",
  "Minute": "الدقيقة",
  "Second": "الثانية",
  "Fuel Amount (Ordered)": "كمية الوقود (المطلوبة)",
  "Liter Price": "سعر اللتر",
  "Dip Start": "القياس اليدوي قبل التفريغ",
  "Dip End": "القياس اليدوي بعد التفريغ",

  // ───── Order Reports ─────
  "Not allowed": "غير مسموح",
  "You are not authorized to access that station.": "ليس لديك صلاحية للوصول إلى هذه المحطة.",
  "Could not load report": "تعذّر تحميل التقرير",
  "Request failed ({0})": "فشل الطلب ({0})",
  "End this period and start a new one?": "إنهاء هذه الفترة وبدء فترة جديدة؟",
  "Start a new period?": "بدء فترة جديدة؟",
  "The current period closes now, its report is saved, and the next period begins at the same moment.": "ستُغلق الفترة الحالية الآن ويُحفظ تقريرها، وتبدأ الفترة التالية في اللحظة نفسها.",
  "Order sales from this moment on will be counted in the new period.": "مبيعات الطلبات من هذه اللحظة ستُحسب في الفترة الجديدة.",
  "End and start new": "إنهاء وبدء فترة جديدة",
  "Period closed": "تم إغلاق الفترة",
  "Period started": "بدأت الفترة",
  "Could not toggle period": "تعذّر تبديل الفترة",
  "Rebuild this report?": "إعادة بناء هذا التقرير؟",
  "The saved report will be replaced with the sales as they stand now. Anything already exported keeps the old figures — this changes what the system shows from here on.": "سيُستبدل التقرير المحفوظ بالمبيعات كما هي الآن. ما تم تصديره سابقاً يبقى بالأرقام القديمة — هذا يغيّر ما يعرضه النظام من الآن فصاعداً.",
  "Rebuild": "إعادة البناء",
  "Report rebuilt": "تمت إعادة بناء التقرير",
  "Could not rebuild": "تعذّرت إعادة البناء",
  "Report period": "فترة التقرير",
  "Choose a station first": "اختر محطة أولاً",
  "No periods yet": "لا توجد فترات بعد",
  "Close the open period and start the next one": "إغلاق الفترة المفتوحة وبدء التالية",
  "Pick a single station first — periods are per station": "اختر محطة واحدة أولاً — الفترات خاصة بكل محطة",
  "Working…": "جارٍ التنفيذ…",
  "End / Start Period": "إنهاء / بدء فترة",
  "Start Period": "بدء فترة",
  "Refresh Report": "تحديث التقرير",
  "Show Report": "عرض التقرير",
  "Hide": "إخفاء",
  "Order periods are kept per station. Pick one station above to start or view a period.": "فترات الطلبات محفوظة لكل محطة على حدة. اختر محطة واحدة في الأعلى لبدء فترة أو عرضها.",
  "{0} sale{1} arrived after this report was saved.": "وصلت {0} عملية بيع بعد حفظ هذا التقرير.",
  "The sales behind this report have changed since it was saved.": "تغيّرت المبيعات التي بُني عليها هذا التقرير منذ حفظه.",
  "This report still shows the saved figures.": "هذا التقرير ما زال يعرض الأرقام المحفوظة.",
  "Rebuilding…": "جارٍ إعادة البناء…",
  "Rebuild report": "إعادة بناء التقرير",
  "Orders:": "الطلبات:",
  "Live — still open": "مباشر — ما زالت مفتوحة",
  "Saved {0}": "حُفظ {0}",
  "No order sales recorded in this period.": "لا توجد مبيعات طلبات مسجلة في هذه الفترة.",

  // ───── Orders page ─────
  "or type a serial": "أو اكتب رقماً تسلسلياً",
  "Add": "إضافة",
  "One order can be valid at several stations. Pick from the list or type a serial and press Enter.": "يمكن أن يكون الطلب صالحاً في عدة محطات. اختر من القائمة أو اكتب رقماً تسلسلياً واضغط Enter.",
  "row {0}": "السطر {0}",
  "Open order": "طلب مفتوح",
  " at {0}": " في {0}",
  "Same as {0}": "مطابق لـ {0}",
  "{0} litres": "{0} لتر",
  "Diesel or Unleaded": "ديزل أو بنزين",
  "Choose a station": "اختر محطة",
  "At least one station is required.": "مطلوب محطة واحدة على الأقل.",
  "Row {0} is incomplete": "السطر {0} غير مكتمل",
  "Still needed: <b>{0}</b>": "الحقول الناقصة: <b>{0}</b>",
  "Check the amounts": "تحقق من الكميات",
  "Row {0} needs an amount greater than 0.": "السطر {0} يحتاج كمية أكبر من 0.",
  "Could not check for duplicates": "تعذّر التحقق من التكرار",
  "The existing orders could not be loaded, so a duplicate plate or TIN cannot be ruled out. Create these orders anyway?": "تعذّر تحميل الطلبات الحالية، لذلك لا يمكن التأكد من عدم تكرار اللوحة أو الرقم الضريبي. هل تريد إنشاء هذه الطلبات على أي حال؟",
  "Create anyway": "إنشاء على أي حال",
  "Duplicate found": "يوجد تكرار",
  "{0} duplicates found": "يوجد {0} تكرارات",
  "An open order already exists at this station. Each one has to be used at the pump before a new order can be created with the same plate or TIN there.": "يوجد طلب مفتوح مسبقاً في هذه المحطة. يجب استخدام كل طلب على المضخة قبل إنشاء طلب جديد بنفس اللوحة أو الرقم الضريبي فيها.",
  "<b>Row {0}</b> — {1} <b>{2}</b>": "<b>السطر {0}</b> — {1} <b>{2}</b>",
  "is already on order <b>{0}</b>": "موجود مسبقاً في الطلب <b>{0}</b>",
  "is the same as {0} in this form": "مطابق لـ {0} في هذا النموذج",
  "{0} of {1} orders created": "تم إنشاء {0} من أصل {1} طلب",
  "These rows failed:": "فشلت هذه الأسطر:",
  "<b>Row {0}</b> — {1}": "<b>السطر {0}</b> — {1}",
  "Orders Ready — {0} of {1}": "الطلبات جاهزة — {0} من {1}",
  "Create Fuel Orders": "إنشاء طلبات وقود",
  " · Diesel or Unleaded": " · ديزل أو بنزين",
  "Not sent to station": "لم يُرسل إلى المحطة",
  "Order QR Code": "رمز QR للطلب",
  "Row {0} failed": "فشل السطر {0}",
  "Scan at the pump, or print to hand over. Each order is good for one use and cannot be recharged.": "امسحه عند المضخة، أو اطبعه لتسليمه. كل طلب صالح لاستخدام واحد ولا يمكن إعادة شحنه.",
  "All ({0})": "الكل ({0})",
  "Done": "تم",
  "How many orders?": "كم عدد الطلبات؟",
  "Order #{0}": "الطلب رقم {0}",
  "Remove this row": "حذف هذا السطر",
  "Amount (Litres) *": "الكمية (لتر) *",
  "Product *": "المنتج *",
  "Select product…": "اختر المنتج…",
  "License Plate *": "لوحة المركبة *",
  "TIN Number *": "الرقم الضريبي (TIN) *",
  "Driver Name *": "اسم السائق *",
  "+ Add Row": "+ إضافة سطر",
  "Every field is required. A plate or TIN that already has an open order": "كل الحقول مطلوبة. اللوحة أو الرقم الضريبي الذي لديه طلب مفتوح",
  "at the same station": "في نفس المحطة",
  "cannot be given another one until that order is used at the pump. A QR code is generated for each order once saved. Every order is fixed at its amount, cannot be recharged, and is removed automatically once fully spent.": "لا يمكن إعطاؤه طلباً آخر حتى يُستخدم ذلك الطلب على المضخة. يُنشأ رمز QR لكل طلب بعد حفظه. كل طلب ثابت بكميته، ولا يمكن إعادة شحنه، ويُحذف تلقائياً عند استهلاكه بالكامل.",
  "Creating {0} / {1}…": "جارٍ إنشاء {0} / {1}…",
  "Create {0}": "إنشاء {0}",
  "{0} Orders": "{0} طلبات",
  "Order": "طلب",
  "Incomplete order": "طلب غير مكتمل",
  "Could not update order": "تعذّر تحديث الطلب",
  "Edit Order — {0}": "تعديل الطلب — {0}",
  "Amount ({0}": "الكمية ({0}",
  "litres": "لتر",
  ") and remaining balance are fixed and cannot be changed here.": ") والرصيد المتبقي ثابتان ولا يمكن تغييرهما هنا.",
  "Remaining": "المتبقي",
  "QR": "QR",
  "Edit": "تعديل",
  "Delete": "حذف",
  "Order QR — {0}": "رمز QR للطلب — {0}",
  "total": "الإجمالي",
  "remaining": "متبقٍ",
  "Delete this order?": "حذف هذا الطلب؟",
  "<small>Remaining: {0}</small>": "<small>المتبقي: {0}</small>",
  "Order removed.": "تم حذف الطلب.",
  "Fuel Orders": "طلبات الوقود",
  "Create Order": "إنشاء طلب",
  "No orders for this station.": "لا توجد طلبات لهذه المحطة.",
  "No orders yet — create one to get started.": "لا توجد طلبات بعد — أنشئ طلباً للبدء.",
  "Create your first order": "أنشئ أول طلب",
  "{0} left": "متبقٍ {0}",
  "No driver name": "لا يوجد اسم سائق",
  "Show / print QR": "عرض / طباعة QR",
  "Edit order": "تعديل الطلب",
  "Delete order": "حذف الطلب",

  // ───── Periodic Reports page (and printed periodic report) ─────
  "****START OF PERIODIC REPORT****": "****بداية التقرير الدوري****",
  "logo": "الشعار",
  "MOBILE:": "الجوال:",
  "TIN:": "الرقم الضريبي:",
  "VRN:": "رقم VRN:",
  "SERIAL NUMBER:": "الرقم التسلسلي:",
  "UIN:": "رقم UIN:",
  "TAX OFFICE:": "مكتب الضرائب:",
  "START:": "البداية:",
  "END:": "النهاية:",
  "TOTAL LITRE:": "إجمالي اللترات:",
  "{0} Ltr": "{0} لتر",
  "TOTAL AMOUNT:": "المبلغ الإجمالي:",
  "DISCOUNT AMOUNT:": "مبلغ الخصم:",
  "NET AMOUNT:": "المبلغ الصافي:",
  "Product-Wise Details": "التفاصيل حسب المنتج",
  "Receipts": "الإيصالات",
  "****END OF PERIODIC REPORT****": "****نهاية التقرير الدوري****",
  "Select shift period (Start and end of shift).": "اختر فترة الوردية (بداية الوردية ونهايتها).",
  "Select Shift Period (Start and end times will be the same)": "اختر فترة الوردية (سيكون وقتا البداية والنهاية متطابقين)",
  "Custom Starting Date": "تاريخ بداية مخصص",
  "Since": "من",
  "Custom End Date": "تاريخ نهاية مخصص",
  "To": "إلى",
  "Available Stations": "المحطات المتاحة",
  "customized table": "جدول مخصص",
  "Daily (Current)": "يومي (الحالي)",
  "Amount (TL)": "المبلغ",
  "Daily (Previous)": "يومي (السابق)",
  "Monthly (Current)": "شهري (الحالي)",
  "Monthly (Previous)": "شهري (السابق)",
  "Custom": "مخصص",

  // ───── TRA Receipts / Transactions page ─────
  "This filter matches {0} records, which is too many to export at once (limit {1}). Please narrow your date range or filters and try again.": "هذه التصفية تطابق {0} سجل، وهذا أكثر من الحد المسموح للتصدير دفعة واحدة (الحد {1}). يرجى تضييق نطاق التاريخ أو التصفية والمحاولة مجدداً.",
  "Receipt ID": "رقم الإيصال",
  "Station Name": "اسم المحطة",
  "Creation Date": "تاريخ الإنشاء",
  "Pump Name": "اسم المضخة",
  "Product Name": "اسم المنتج",
  "Verification Link": "رابط التحقق",
  "Export failed: {0}": "فشل التصدير: {0}",
  "No verification link available for this sale.": "لا يوجد رابط تحقق لعملية البيع هذه.",
  "Error fetching receipt\n{0}": "خطأ في جلب الإيصال\n{0}",
  "Nozzle Name: {0}, Nozzle Number: {1}": "اسم المسدس: {0}، رقم المسدس: {1}",
  "Tank Name: {0}": "اسم الخزان: {0}",
  "Product Name: {0}": "اسم المنتج: {0}",
  "*Click on": "*اضغط على زر",
  "button in": "في",
  "Filters": "التصفية",
  "to download Excel sheet.": "لتنزيل ملف Excel.",
  "Select filters": "اختر معايير التصفية",
  "Select Station": "اختر المحطة",
  "Pumps": "المضخات",
  "Select Pump": "اختر المضخة",
  "Nozzles": "المسدسات",
  "Select Nozzle": "اختر المسدس",
  "Tanks": "الخزانات",
  "Select Tank": "اختر الخزان",
  "Products": "المنتجات",
  "Select Product": "اختر المنتج",
  "Exact match": "مطابقة تامة",
  "Tag ID": "رقم الوسم (Tag)",
  "Since Date": "من تاريخ",
  "Select Start Date": "اختر تاريخ البداية",
  "To Date": "إلى تاريخ",
  "Select End Date": "اختر تاريخ النهاية",
  "Exporting...": "جارٍ التصدير...",
  "Clear Fields": "مسح الحقول",
  "Preparing export... This may take a moment for large datasets.": "جارٍ تجهيز التصدير... قد يستغرق ذلك بعض الوقت للبيانات الكبيرة.",
  "Select columns to view and hide": "اختر الأعمدة لإظهارها أو إخفائها",
  "Sales ID": "رقم عملية البيع",
  "Nozzle": "المسدس",
  "Fuel": "الوقود",
  "Unit Price": "سعر الوحدة",
  "Loading reports data...": "جارٍ تحميل بيانات التقارير...",
  "Receipt": "الإيصال",
  "Print receipt": "طباعة الإيصال",

  // ───── Stations page ─────
  "<b>{0}</b> in {1}": "<b>{0}</b> في {1}",
  "Change the station serial?": "تغيير الرقم التسلسلي للمحطة؟",
  "These records will be moved to the new serial:": "سيتم نقل هذه السجلات إلى الرقم التسلسلي الجديد:",
  "No existing records reference the current serial.": "لا توجد سجلات مرتبطة بالرقم التسلسلي الحالي.",
  "This can take a while and cannot be undone from here.": "قد يستغرق هذا بعض الوقت ولا يمكن التراجع عنه من هنا.",
  "Yes, change it": "نعم، غيّره",
  "Station updated. {0} record(s) moved to {1}.": "تم تحديث المحطة. نُقل {0} سجل إلى {1}.",
  "Station {0} successfully.": "تم {0} المحطة بنجاح.",
  "updated": "تحديث",
  "created": "إنشاء",
  "Validation Error": "خطأ في البيانات",
  "Please check your input data.": "يرجى التحقق من البيانات المدخلة.",
  "Station not found.": "المحطة غير موجودة.",
  "Request failed ({0}).": "فشل الطلب ({0}).",
  "Edit Station": "تعديل المحطة",
  "Add New Station": "إضافة محطة جديدة",
  "Station Name *": "اسم المحطة *",
  "EWURA License No *": "رقم ترخيص EWURA *",
  "Distributor ID *": "رقم الموزّع *",
  "Licensee Serial No *": "الرقم التسلسلي للمرخَّص له *",
  "Changing this rewrites every sales, card and tank record that references the old serial.": "تغيير هذا الحقل يعيد كتابة كل سجلات المبيعات والبطاقات والخزانات المرتبطة بالرقم التسلسلي القديم.",
  "Operator Name": "اسم المشغّل",
  "Operator TIN": "الرقم الضريبي للمشغّل",
  "Operator X TIN": "الرقم الضريبي X للمشغّل",
  "Operator VRN": "رقم VRN للمشغّل",
  "Operator UIN": "رقم UIN للمشغّل",
  "Region": "المنطقة",
  "District": "المقاطعة",
  "Ward": "الحي",
  "Contact Email": "البريد الإلكتروني للتواصل",
  "Contact Phone": "هاتف التواصل",
  "Tank Alarm Volume": "كمية إنذار الخزان",
  "Litres. An alarm is raised below this level.": "باللتر. يُطلق إنذار عند النزول تحت هذا المستوى.",
  "Station URL": "رابط المحطة",
  "Default Printer IP": "عنوان IP للطابعة الافتراضية",
  "Is VFD Enabled": "هل VFD مفعّل؟",
  "Total No. Tanks": "إجمالي عدد الخزانات",
  "Mobile Groups (comma-separated)": "مجموعات الجوال (مفصولة بفاصلة)",
  "Mobile Group 1": "مجموعة الجوال 1",
  "Enter mobile numbers separated by commas": "أدخل أرقام الجوال مفصولة بفواصل",
  "Mobile Group 2": "مجموعة الجوال 2",
  "Saving...": "جارٍ الحفظ...",
  "Update Station": "تحديث المحطة",
  "Add Station": "إضافة محطة",
  "Not Found": "غير موجود",
  "Station not found with the provided name.": "لا توجد محطة بهذا الاسم.",
  "Search Station": "البحث عن محطة",
  "Choose a station to search": "اختر محطة للبحث",
  "Searching...": "جارٍ البحث...",
  "Only registered stations are accepted — select a station to retrieve and modify its information.": "تُقبل المحطات المسجلة فقط — اختر محطة لعرض معلوماتها وتعديلها.",
  "Failed to fetch stations.": "فشل جلب المحطات.",
  "Station Selected!": "تم اختيار المحطة!",
  "Selected: {0}": "المحدد: {0}",
  "Are you sure?": "هل أنت متأكد؟",
  "This will permanently delete the station!": "سيتم حذف المحطة نهائياً!",
  "Yes, delete it!": "نعم، احذفها!",
  "Deleted!": "تم الحذف!",
  "Station has been deleted.": "تم حذف المحطة.",
  "Select this station": "اختيار هذه المحطة",
  "Edit station": "تعديل المحطة",
  "Delete station": "حذف المحطة",
  "Open Automation Interface": "فتح واجهة الأتمتة",
  "No automation link set": "لا يوجد رابط أتمتة",
  "Operator:": "المشغّل:",
  "Region:": "المنطقة:",
  "District:": "المقاطعة:",
  "Alarm Volume:": "كمية الإنذار:",
  "{0} L": "{0} ل",
  "Contact:": "التواصل:",
  "Phone:": "الهاتف:",
  "Tanks:": "الخزانات:",
  "Location:": "الموقع:",
  "Stations": "المحطات",
  "Manage fuel stations and open their automation interfaces": "إدارة محطات الوقود وفتح واجهات الأتمتة الخاصة بها",
  "Currently Selected Station": "المحطة المحددة حالياً",
  "Station Management": "إدارة المحطات",
  "Add, edit, search, and delete fuel stations": "إضافة محطات الوقود وتعديلها والبحث عنها وحذفها",
  "Search & Edit Station": "البحث عن محطة وتعديلها",
  "Refreshing...": "جارٍ التحديث...",
  "Refresh List": "تحديث القائمة",
  "All Stations ({0})": "كل المحطات ({0})",
  "Select, edit, or delete existing fuel stations": "اختيار محطات الوقود الموجودة أو تعديلها أو حذفها",
  "{0} VFD, {1} ATG": "{0} VFD، {1} ATG",
  "VFD Stations": "محطات VFD",
  "ATG Stations": "محطات ATG",
  "No stations found. Add your first station using the \"Add New Station\" button.": "لا توجد محطات. أضف أول محطة باستخدام زر «إضافة محطة جديدة».",
  "No station matches your search.": "لا توجد محطة تطابق البحث.",

  // ───── Dashboard / Statistics page ─────
  "Today": "اليوم",
  "Yesterday": "أمس",
  "This Month": "هذا الشهر",
  "Last Month": "الشهر الماضي",
  "Unleaded": "بنزين",
  "Diesel": "ديزل",
  "Could not load statistics.": "تعذّر تحميل الإحصائيات.",
  "Could not load statistics": "تعذّر تحميل الإحصائيات",
  "Statistics": "الإحصائيات",
  "Volume, revenue and receipts by product, with the leading station and region for the selected period.": "الكميات والإيرادات والإيصالات حسب المنتج، مع المحطة والمنطقة الأعلى في الفترة المحددة.",
  "Live": "مباشر",
  "Loading": "جارٍ التحميل",
  "Total Volume": "إجمالي الكمية",
  "Total Amount": "إجمالي المبلغ",
  "Transactions": "المعاملات",
  "Top station": "المحطة الأعلى",
  "{0} L ·": "{0} ل ·",
  "{0} TSH": "{0} شلن",
  "No sales": "لا توجد مبيعات",
  "Top region": "المنطقة الأعلى",
  "No region data": "لا توجد بيانات للمناطق",

  // ───── Users page ─────
  "Developer access — full system control across all stations.": "صلاحية المطوّر — تحكم كامل بالنظام في كل المحطات.",
  "Global access across all stations. Can create users.": "صلاحية عامة على كل المحطات. يمكنه إنشاء مستخدمين.",
  "Bound to multiple explicitly associated stations.": "مرتبط بعدة محطات محددة.",
  "Bound to a single associated station.": "مرتبط بمحطة واحدة.",
  "Report reader — global view of Close, Offloading & Periodic Reports.": "قارئ تقارير — عرض عام لتقارير الإغلاق والتفريغ والتقارير الدورية.",
  "At least one station": "محطة واحدة على الأقل",
  "A Cluster Manager must keep at least one station.": "يجب أن تبقى لمدير المجموعة محطة واحدة على الأقل.",
  "{0}'s stations were updated.": "تم تحديث محطات {0}.",
  "Could not update": "تعذّر التحديث",
  "Edit stations": "تعديل المحطات",
  "No stations assigned.": "لا توجد محطات مرتبطة.",
  "Could not load Cluster Managers.": "تعذّر تحميل مديري المجموعات.",
  "Enter a valid email address.": "أدخل بريداً إلكترونياً صحيحاً.",
  "Password must be at least 6 characters.": "يجب أن تكون كلمة المرور 6 أحرف على الأقل.",
  "{0} must be assigned a station.": "يجب ربط {0} بمحطة.",
  "{0} must be assigned at least one station.": "يجب ربط {0} بمحطة واحدة على الأقل.",
  "A Manager can be bound to only one station.": "المدير يمكن ربطه بمحطة واحدة فقط.",
  "Check the form": "تحقق من النموذج",
  "User created": "تم إنشاء المستخدم",
  "<b>{0}</b> was created as <b>{1}</b>.": "تم إنشاء <b>{0}</b> بصلاحية <b>{1}</b>.",
  "Could not create user": "تعذّر إنشاء المستخدم",
  "User Management": "إدارة المستخدمين",
  "Create accounts for the central reporting platform. Each user’s role decides their station scope and what they can access. Only a Cluster Manager’s station assignment can be edited after creation — everything else is create-only.": "أنشئ حسابات لمنصة التقارير المركزية. دور كل مستخدم يحدد محطاته وما يمكنه الوصول إليه. فقط محطات مدير المجموعة يمكن تعديلها بعد الإنشاء — أما باقي البيانات فتُحدد عند الإنشاء فقط.",
  "Create a user": "إنشاء مستخدم",
  "Fill in the details and assign a role.": "املأ البيانات وحدد الدور.",
  "Email address": "البريد الإلكتروني",
  "name@company.com": "name@company.com",
  "At least 6 characters": "6 أحرف على الأقل",
  "Toggle password": "إظهار/إخفاء كلمة المرور",
  "Role": "الدور",
  "CAN CREATE": "يمكنه الإنشاء",
  "Global — all stations": "عام — كل المحطات",
  "Multiple stations": "عدة محطات",
  "Single station": "محطة واحدة",
  "Associated station": "المحطة المرتبطة",
  "Associated stations": "المحطات المرتبطة",
  "Only registered stations are accepted — the server rejects any serial it doesn’t recognise.": "تُقبل المحطات المسجلة فقط — يرفض الخادم أي رقم تسلسلي لا يعرفه.",
  "Creating…": "جارٍ الإنشاء…",
  "Create user": "إنشاء المستخدم",
  "Cluster Managers": "مديرو المجموعات",
  "The only accounts whose station assignment can change after creation.": "الحسابات الوحيدة التي يمكن تغيير محطاتها بعد الإنشاء.",
  "Retry": "إعادة المحاولة",
  "No Cluster Managers yet.": "لا يوجد مديرو مجموعات بعد.",

  // ───── Station Map page ─────
  "STATION MAP": "خريطة المحطات",
  "Sales": "المبيعات",
  "Stock": "المخزون",
  "Petrol": "بنزين",
  "Other": "أخرى",
  "Last 7 days": "آخر 7 أيام",
  "This month": "هذا الشهر",
  "No report": "لا يوجد تقرير",
  "Plus Code": "رمز الموقع",
  "Open in Google Maps": "فتح في خرائط Google",
  "no ATG data": "لا توجد بيانات ATG",
  "ATG read": "قراءة ATG",
  "old": "قديمة",
  "Amount (TZS)": "المبلغ (شلن)",
  "Fuel shorts": "عجز الوقود",
  "No close report for this day.": "لا يوجد تقرير إغلاق لهذا اليوم.",
  "Minus = fuel short.": "السالب = عجز في الوقود.",
  "No petrol or diesel tank in the close report.": "لا يوجد خزان بنزين أو ديزل في تقرير الإغلاق.",
  "stations": "محطات",
  "From date is after To date.": "تاريخ البداية بعد تاريخ النهاية.",
  "Pick a shorter period": "اختر فترة أقصر",
  "days or less": "يوماً أو أقل",
  "Session expired, please log in again.": "انتهت الجلسة، يرجى تسجيل الدخول مجدداً.",
  "Failed to load the map data.": "تعذّر تحميل بيانات الخريطة.",
  "Failed to load the tank data.": "تعذّر تحميل بيانات الخزانات.",
  "Could not load the close reports of {0}: {1}": "تعذّر تحميل تقارير الإغلاق لـ {0}: {1}",
  "Map shows": "تعرض الخريطة",
  "From": "من",
  "Previous day": "اليوم السابق",
  "Close report of": "تقرير إغلاق يوم",
  "Next day": "اليوم التالي",
  "Search station / region": "ابحث عن محطة / منطقة",
  "Fit all": "عرض الكل",
  "Stations on map": "المحطات على الخريطة",
  "All stations together. Minus = fuel short.": "مجموع كل المحطات. السالب = عجز في الوقود.",
  "Petrol short": "عجز البنزين",
  "Diesel short": "عجز الديزل",
  "Total short": "إجمالي العجز",
  "Stations short": "محطات فيها عجز",
  "Close reports": "تقارير الإغلاق",
  "No station has a location yet.": "لا توجد محطة لها موقع على الخريطة بعد.",
  "Put each station's Plus Code in its Zone, e.g.": "ضع رمز موقع كل محطة في حقل «موقع الخريطة» الخاص بها، مثال:",
  "Petrol (L)": "بنزين (ل)",
  "Diesel (L)": "ديزل (ل)",
  "Total (L)": "الإجمالي (ل)",
  "Show on map": "عرض على الخريطة",
  "No close report for this day": "لا يوجد تقرير إغلاق لهذا اليوم",
  // Station map leaderboard: product columns + fuel shorts period
  "Leaderboard": "ترتيب المحطات",
  "Columns": "الأعمدة",
  "No close report in this period": "لا يوجد تقرير إغلاق في هذه الفترة",
  "No close report in this period.": "لا يوجد تقرير إغلاق في هذه الفترة.",
  "Close reports: {0} of {1} days": "أيام تقارير الإغلاق: {0} من {1}",
  "{0} more not on map": "و{0} غير موجودة على الخريطة",
  "No ATG": "لا يوجد ATG",
  "No ATG at this station": "لا يوجد ATG في هذه المحطة",
  "No ATG at this station - its fuel shorts are not counted.": "لا يوجد ATG في هذه المحطة، لذلك لا يُحسب عجز الوقود لها.",
  "Show": "إظهار",
  "stations not on map": "المحطات غير الظاهرة على الخريطة",
  "In Google Maps, open the station and copy its Plus Code with the town, e.g.": "في خرائط Google افتح المحطة وانسخ رمز موقعها (Plus Code) مع اسم المدينة، مثال:",
  "- then put it in the station's Zone. A full code (6G5X672J+V7) or coordinates (-6.797813, 39.280688) also work.": "— ثم ضعه في حقل «موقع الخريطة» للمحطة. ويصلح أيضاً الرمز الكامل (6G5X672J+V7) أو الإحداثيات (-6.797813, 39.280688).",
  "Zone now": "موقع الخريطة الحالي",
  "Why not on map": "سبب عدم ظهورها",

  // ───── Stations page (map location, automation) ─────
  "Map location: copy the Plus Code from Google Maps with the town, e.g. 672J+V7 Dar es Salaam": "موقع الخريطة: انسخ رمز الموقع (Plus Code) من خرائط Google مع اسم المدينة، مثال: 672J+V7 Dar es Salaam",
  "Coordinates - OK for the map.": "إحداثيات — صالحة للخريطة.",
  "No Plus Code found - this station will not show on the map. Example: 672J+V7 Dar es Salaam": "لا يوجد رمز موقع — لن تظهر هذه المحطة على الخريطة. مثال: 672J+V7 Dar es Salaam",
  "Full Plus Code {0} - OK for the map.": "رمز موقع كامل {0} — صالح للخريطة.",
  "Add the town after the code, e.g. {0} Dar es Salaam - or fill in the station's Region.": "أضف اسم المدينة بعد الرمز، مثال: {0} Dar es Salaam — أو املأ حقل المنطقة للمحطة.",
  "Plus Code {0} with no town: placed using the station's District/Region ({1}). Right only if the station is within ~50 km of that town - otherwise add the nearest town after the code.": "رمز الموقع {0} بلا مدينة: حُدِّد المكان من مقاطعة/منطقة المحطة ({1}). يكون صحيحاً فقط إذا كانت المحطة على بُعد 50 كم تقريباً من تلك المدينة أو أقل — وإلا فأضف أقرب مدينة بعد الرمز.",
  "Plus Code {0} near {1} - OK for the map.": "رمز الموقع {0} قرب {1} — صالح للخريطة.",
  "Zone (map location)": "موقع الخريطة (Zone)",
  "Check in Google Maps": "تحقق في خرائط Google",
  "Could not open the automation interface: {0}": "تعذّر فتح واجهة الأتمتة: {0}",
  "Ward:": "الحي:",
  "Zone:": "موقع الخريطة:",
  "not on map": "غير ظاهرة على الخريطة",
  "not set": "غير محدد",

  // ───── Close Reports page (status, day variation, custom report) ─────
  "No stations.": "لا توجد محطات.",
  "Downloaded {0} ({1} of {2} stations).": "تم تنزيل {0} ({1} من أصل {2} محطة).",
  "Today's Close Status": "حالة الإغلاق اليوم",
  "as of {0}": "حتى {0}",
  "Hide Close Status": "إخفاء حالة الإغلاق",
  "Show Close Status": "إظهار حالة الإغلاق",
  "Closed": "تم الإغلاق",
  "Status resets daily at 00:00 (midnight).": "تُصفَّر الحالة يومياً عند الساعة 00:00 (منتصف الليل).",
  "Close Time": "وقت الإغلاق",
  "Update Time": "وقت التحديث",
  "Day Variation (fuel shorts) - all stations": "فرق اليوم (عجز الوقود) — كل المحطات",
  "Day of the close reports (yesterday by default)": "يوم تقارير الإغلاق (أمس افتراضياً)",
  "Download Day Variation (Excel)": "تنزيل فرق اليوم (Excel)",
  "Please select a station.": "يرجى اختيار محطة.",
  "Please select a start and an end date.": "يرجى اختيار تاريخ البداية وتاريخ النهاية.",
  "The start date must be before the end date.": "يجب أن يكون تاريخ البداية قبل تاريخ النهاية.",
  "Searching close reports": "جارٍ البحث عن تقارير الإغلاق",
  "No close reports for {0} between {1} and {2}.": "لا توجد تقارير إغلاق لـ {0} بين {1} و{2}.",
  "Downloaded: {0} to {1}, from {2} daily close report(s).": "تم التنزيل: من {0} إلى {1}، من {2} تقرير إغلاق يومي.",
  "Warning: missing close report(s) for {0} — sales and deliveries in those hours are not included.": "تنبيه: تقارير إغلاق ناقصة للفترة {0} — المبيعات والتوريدات في تلك الساعات غير مشمولة.",
  "Custom Close Report ": "تقرير إغلاق مخصص",
  "First close report starts this day": "أول تقرير إغلاق يبدأ في هذا اليوم",
  "Last close report starts this day": "آخر تقرير إغلاق يبدأ في هذا اليوم",
  "Download Custom Close Report (Excel)": "تنزيل تقرير الإغلاق المخصص (Excel)",

  // ───── Orders page ─────
  // "Amount" of an order is litres, not money - so it has its own entry
  // (Orders.js calls trc('litres', 'Amount')).
  "litres::Amount": "الكمية",
  "Use A123ABC, AB12 or ABC12 — capital letters only": "استخدم A123ABC أو AB12 أو ABC12 — بأحرف كبيرة فقط",
  "Check the plate": "تحقق من اللوحة",
  "Check the plates": "تحقق من اللوحات",
  "(empty)": "(فارغ)",
  "e.g. T324DLS": "مثال: T324DLS",
  "cannot be given another one until that order is used at the pump. A QR code is generated for each order once saved. Every order is fixed at its amount and cannot be recharged.": "لا يمكن إعطاؤه طلباً آخر حتى يُستخدم ذلك الطلب على المضخة. يُنشأ رمز QR لكل طلب بعد حفظه. كل طلب ثابت بكميته ولا يمكن إعادة شحنه.",
  "One use only": "استخدام واحد فقط",
  "— the first fill ends the order even if litres are left on it, and any order not used within": "— أول تعبئة تُنهي الطلب حتى لو بقيت فيه لترات، وأي طلب لا يُستخدم خلال",
  "24 hours": "24 ساعة",
  "is removed automatically.": "يُحذف تلقائياً.",

  // ───── Offloading Reports page ─────
  "Station type": "نوع المحطة",
  "ATG Only": "ATG فقط",
  "All VFD Stations": "كل محطات VFD",
  "All My VFD Stations": "كل محطات VFD الخاصة بي",
  "All ATG Stations": "كل محطات ATG",
  "All My ATG Stations": "كل محطات ATG الخاصة بي",

  // ───── Users page ─────
  "Manufacture account bound to a single station.": "حساب معمل مرتبط بمحطة واحدة.",
  "Buses operations manager bound to a single station.": "مدير عمليات الحافلات، مرتبط بمحطة واحدة.",
  "Bound to a single station. Sees Buses Reports only.": "مرتبط بمحطة واحدة. يرى تقارير الحافلات فقط.",
  "Bound to a single station. Sees Reports, Close & Offloading Reports and ATG only.": "مرتبط بمحطة واحدة. يرى التقارير وتقارير الإغلاق والتفريغ وATG فقط.",
  "{0} can be bound to only one station.": "{0} يمكن ربطه بمحطة واحدة فقط.",

  // ───── TRA Receipts export ─────
  "RECEIPT VERIFICATION CODE": "رمز التحقق من الإيصال",

  // ───── Footer tools (scroll, display size, theme) ─────
  "Scroll left": "تمرير لليسار",
  "Scroll right": "تمرير لليمين",
  "Auto": "تلقائي",
  "Display size": "حجم العرض",
  "Switch to light mode": "التبديل إلى الوضع الفاتح",
  "Switch to dark mode": "التبديل إلى الوضع الداكن",

  // ───── Menu names and role names ─────
  "DASHBOARD": "لوحة التحكم",
  "TRA RECEIPTS": "إيصالات TRA",
  "TRANSICTIONS": "المعاملات",
  "PERIODIC REPORTS": "التقارير الدورية",
  "CLOSE REPORTS": "تقارير الإغلاق",
  "OFFLOADING REPORTS": "تقارير التفريغ",
  "ATG": "مراقبة الخزانات",
  "STATIONS": "المحطات",
  "USERS": "المستخدمون",
  "CLIENT CARDS": "بطاقات العملاء",
  "CARDS": "البطاقات",
  "ATTENDANT CARDS": "بطاقات العمّال",
  "ORDERS": "الطلبات",
  "BUSES REPORTS": "تقارير الحافلات",
  "Buses Manager": "مدير الحافلات",
  "Superadmin": "المشرف العام",
  "Manager": "مدير",
  "Cluster Manager": "مدير مجموعة",
  "Admin": "مسؤول",
  "Auditor": "مدقق",
  "Manufacture": "حساب معمل",
  "Buses Accountant": "محاسب الحافلات",
  "Manufacture Accountant":"محاسب المعمل",
  "Attendant": "عامل",
  "User": "مستخدم",
  "Guest": "زائر"
};

export default ar;